import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Typography } from '../../design-system';
import { useIsVisible, useRepairsQuery } from '../../hooks';
import {
  CloseIconButton,
  DashboardHeader,
  DashboardTable,
  DashboardTableCell,
  DashboardTableHeader,
  DashboardTableRow,
  DashboardTableRowLoading,
  DashboardTableRows,
  DashboardWrapper,
} from '../dashboard';
import { repairStatusLabel } from '../../const';
import { RepairsView } from './RepairsView';

export const Repairs = () => {
  const navigate = useNavigate();
  const { id = '' } = useParams();
  const location = useLocation();
  const [isVisibleLoading, loadingRef] = useIsVisible();
  const [isOpenFormPopup, setIsOpenFormPopup] = useState(false);
  const selectedRepair = useRef<any>({});

  const {
    data: { data, totalCount },
    isSuccess,
    isFetched,
    fetchNextPage,
    isFetching,
    refetch,
  } = useRepairsQuery({ containerId: id });

  const containerNumber =
    (location.state as { number?: string })?.number || data[0]?.container?.number || '';

  useEffect(() => {
    if (!isVisibleLoading || isFetching) return;

    fetchNextPage();
  }, [isVisibleLoading]);

  const handleCloseClick = () => {
    navigate('/dashboard/repairs');
  };

  const handleRowClick = (row: any) => {
    selectedRepair.current = row;
    setIsOpenFormPopup(true);
  };

  const handleFormCloseClick = () => {
    setIsOpenFormPopup(false);
  };

  return (
    <DashboardWrapper rows={'4rem 1fr'}>
      <RepairsView
        repair={selectedRepair.current}
        isOpen={isOpenFormPopup}
        refetch={refetch}
        handleFormCloseClick={handleFormCloseClick}
      />
      <DashboardHeader>
        <Typography variant={'textXL'} weight={'bold'}>
          Repairs: {containerNumber}
        </Typography>
        <CloseIconButton onClick={handleCloseClick} />
      </DashboardHeader>
      <DashboardTable>
        <DashboardTableHeader>
          <DashboardTableCell>Description</DashboardTableCell>
          <DashboardTableCell>Status</DashboardTableCell>
          <DashboardTableCell align={'right'}>Days To Complete</DashboardTableCell>
        </DashboardTableHeader>
        <DashboardTableRows>
          {isSuccess &&
            data.map((row, i) => (
              <DashboardTableRow key={i} onClick={() => handleRowClick(row)}>
                <DashboardTableCell>{row.description}</DashboardTableCell>
                <DashboardTableCell>{repairStatusLabel[row.status] || row.status}</DashboardTableCell>
                <DashboardTableCell align={'right'}>{row.expectedDurationDays}</DashboardTableCell>
              </DashboardTableRow>
            ))}
          {(!isFetched || data.length !== totalCount) && (
            <DashboardTableRowLoading key={data.length} setRef={loadingRef} />
          )}
        </DashboardTableRows>
      </DashboardTable>
    </DashboardWrapper>
  );
};
